import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menumobile from '../partils/menus/menumobile';

import Menumain from '../partils/menus/menumain';

import datahappy  from '../../local/datahappy'
// DATA -------------------------------------------------------------------------

  

export default function Perfil() {
    const [loading,setLoading]=useState(false)



    const final= datahappy.map(item => (
      <div key={item.id} className='w100 linha pcb7 row between'>
        <label className='w40 ml10 c1'>{item.titulo}</label>
        <label className='w20 c4'>HelloPost</label>
        <label className='w10 c4'>{item.data}</label>
        <label className='w10 c4'>{item.hora}</label>
        <label className='w10 c7 fw500 pp'>Abrir</label>
      </div>
    ))
  return(
    <div className='w100 h100 b33 row around'>
      {loading&&
      <div className='w100 h100 fundo-opaco posiabste column center'>
          <img src="https://i.pinimg.com/474x/67/d8/37/67d8379604084dd7d7c7fa8d41f4c739.jpg"></img>
      </div>
      }
      <div className='cell-none w15'>
        <Menumain className=""/>
      </div>

      <div className='w80 h90 cont-circ7 cell-tamanho column start' >
       
        <div className='ma10b0'>
         { //<label className='fs08em'>Estamos em construção e com muitas novidades!</label>
         }
        </div>
        
        <h5 className='w95'>Perfil</h5>
      
        <div className='ma10b0 w95'>
         <button>Edit</button>
        </div>
        <div className='w95 h40 b2 cont-circ7 bordaElements'>
          
          <div className='w100 h40 b2 cont-circ7 '>
            <div className='w100 linha pcb7 row between b16'>
              <label className='w40 ml10 c2 fw500 fs08em'>Titulo</label>
              <label className='w20 c2 fw500 fs08em'>Criado:</label>
              <label className='w10 c2 fw500 fs08em'>Preço</label>
              <label className='w10 c2 fw500 fs08em'>Status</label>
              <label className='w10 c2 fw500 fs08em'>Ação</label>
            </div>
            <div className='w100 linha pcb7 row between'>
              <label className='w40 ml10 c1'>Campanha de 1 Posts</label>
              <label className='w20  c4'>HelloPost</label>
              <label className='w10  c4'>Free</label>
              <label className='w10  c4'>Expi.</label>
              <label className='w10  c7 fw500 pp'>Comprar</label>
            </div>
            
          </div>
        </div>

        <div className='w95 row center h10'>
          <label className='cen c2'>
            Hello Post 2022- By Mobi Apps V.BETA
          </label>
        </div>
        <Menumobile/>
         
      </div>
    </div>
  )
}










        
